import { atomWithStorage } from 'jotai/utils'
import { key } from '@/atoms/index'

export const printItemNotesAtom = atomWithStorage(key('printItemNotes'), true)
export const printItemTagsAtom = atomWithStorage(key('printItemTags'), true)
export const printItemResourcesAtom = atomWithStorage(key('printItemResources'), false)
export const printItemLastCommentsAtom = atomWithStorage(key('printItemLastComments'), false)
export const printItemOwnerFollowersAtom = atomWithStorage(key('printItemOwnerFollowers'), false)
